import { Profile } from 'labxchange-client';
import * as React from 'react';
import { WrappedMessage } from 'utils';
import messages from '../displayMessages';
import { intl } from 'i18n';

interface LearnerAtSchoolSignupDetailsProps {
    profile: Profile;
    onUpdateClassCode: (classCode: string) => void;
}

export class LearnerAtSchoolSignupDetails extends React.PureComponent<
    LearnerAtSchoolSignupDetailsProps> {

    public render() {
        return (
            <>
                <div className='signup-details-section'>
                    <label>
                        <span>
                            <WrappedMessage message={messages.classCodeLabel}/>
                            <span> (<WrappedMessage message={messages.optionalText}/>)</span>
                        </span>
                        <input type='text'
                            onBlur={(e) => this.props.onUpdateClassCode(e.target.value)}
                            required={false}
                            aria-required={false}
                            data-type='class-code'
                            placeholder={intl.formatMessage(messages.classCodePlaceholder)}
                        />
                    </label>
                </div>
            </>
        );
    }
}

interface LearnerSignupDetailsProps {
    profile: Profile;
    onUpdateClassCode: (classCode: string) => void;
}

export class LearnerSignupDetails extends React.PureComponent<LearnerSignupDetailsProps> {

    public render() {
        return (
            <>
                <div className='signup-details-section'>
                    <label>
                        <WrappedMessage message={messages.classCodeLabel}/>
                        <span> (<WrappedMessage message={messages.optionalText}/>)</span>
                        <input type='text'
                            onBlur={(e) => this.props.onUpdateClassCode(e.target.value)}
                            required={false}
                            aria-required={false}
                            data-type='class-code'
                            placeholder={intl.formatMessage(messages.classCodePlaceholder)}
                        />
                    </label>
                </div>
            </>
        );
    }
}

interface EducatorSignupDetailsProps {
    profile: Profile;
}

export class EducatorSignupDetails extends React.PureComponent<EducatorSignupDetailsProps> {
    public render() {
        return null;
    }
}
